"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.COMPONENT_UPDATED = void 0;

var _reactDom = _interopRequireDefault(require("react-dom"));

var _backbone = _interopRequireDefault(require("backbone.marionette"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var COMPONENT_UPDATED = 'component:updated';
exports.COMPONENT_UPDATED = COMPONENT_UPDATED;

var ReactView = function (View) {
  return View.extend({
    initialize: function initialize() {
      if (!(this instanceof _backbone.default.ItemView)) {
        console.warn('ReactView mixin is intended for use with ItemViews - behavior may not match expectations');
      }

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      View.prototype.initialize.apply(this, args);
      this.listenTo(this, 'close', this.teardownComponent);
    },
    render: function render() {
      this._ensureElement();

      this._triggerBeforeRendered();

      var props = this.serializeData();
      var isRerender = !!this._component;
      this._component = this.template(props);

      if (isRerender) {
        // If we are re-rendering, we want to call ReactDOM.render() to refresh
        this.mountComponent();
      }

      this._triggerRendered();
    },
    _triggerBeforeRendered: function _triggerBeforeRendered() {
      this.triggerMethod('before:render', this);
      this.triggerMethod('item:before:render', this);
    },
    _triggerRendered: function _triggerRendered() {
      this.triggerMethod('render', this);
      this.triggerMethod('item:rendered', this);
    },
    onShow: function () {
      this.mountComponent();
      var onShow = View.prototype.onShow;

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      onShow && onShow.apply.apply(onShow, [this].concat(args));
    },
    mountComponent: function mountComponent() {
      var _this = this;

      _reactDom.default.render(this._component, this.$el[0], function () {
        return _this.onComponentUpdated();
      });
    },
    onComponentUpdated: function onComponentUpdated() {
      this.trigger(COMPONENT_UPDATED, this._component);
    },
    teardownComponent: function teardownComponent() {
      _reactDom.default.unmountComponentAtNode(this.$el[0]);
    }
  });
};

var _default = ReactView;
exports.default = _default;